export default [{
  path: '/',
  component: () => import('./components/DashboardPage.vue')
}]
